import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20minimalist%20flat%20lay%20of%20fashion%20and%20lifestyle%20products%20including%20sneakers%20and%20accessories%20artfully%20arranged%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20daylight%20from%20large%20window%2C%20editorial%20magazine%20quality%20photography%2C%20clean%20elegant%20composition%2C%20warm%20neutral%20palette%2C%20fresh%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-v2-06&orientation=landscape"
          alt="Pandabuy Sheet — Smart Product Comparison Spreadsheets"
          title="Pandabuy Sheet — Smart Shopping Spreadsheets"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 pt-28 pb-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl mx-auto">
          Smart Product Comparison Spreadsheets for Smarter Buying
        </h1>
        <p className="mt-5 text-sm md:text-lg text-white/85 max-w-xl mx-auto leading-relaxed">
          Discover structured product data, price comparisons, and curated spreadsheets that help you find the best value products online in seconds.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-white text-foreground-950 hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Browse Categories</span>
              <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-background-50 rounded-lg py-3 w-64 max-h-72 overflow-y-auto border border-background-200/70 z-20">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block px-5 py-2.5 text-sm text-foreground-700 hover:bg-accent-100 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Pandabuy Sheet
          </a>
        </div>

        <div className="mt-4">
          <Link
            to="/guide/pandabuy-sheet-guide"
            className="inline-flex items-center px-6 py-3 text-sm font-semibold rounded-full bg-transparent border border-white/60 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Shopping Guide
          </Link>
        </div>
      </div>
    </section>
  );
}